
import { Component, Mixins, Prop, Ref, Emit, Watch } from "vue-property-decorator";
import AuthMixin from "../mixins/auth.mixin";
import { IUser, UserLevel, UserLevels } from "shared/entities/user";
import { CreateUserRequest } from "shared/api/routes/user";
import { BModal } from "bootstrap-vue";
import { apiHandler } from "@/services/api-handler";
import { Api } from "shared/api";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { ILocation } from "shared/entities/location";

@Component({
    components: { VueTypeaheadBootstrap, BModal }
})
export default class AddUser extends Mixins(AuthMixin) {
    addUserProps: CreateUserRequest = {
        locationIds: [],
        firstName: "",
        lastName: "",
        email: "",
        level: UserLevel.Employee,
        ownerId: undefined
    };

    selectedLocationIds: number[] = [];
    localLocations: ILocation[] = [];

    @Prop({ required: true })
    owners!: IUser[];

    @Prop({ required: true })
    locations!: ILocation[];

    @Ref()
    private readonly addUserModel!: BModal;

    UserLevel = UserLevel;

    @Watch("locations", { immediate: true, deep: true })
    onLocationsChanged(newVal: ILocation[]) {
        this.localLocations = [...newVal];
    }

    async created() {
        this.localLocations = [...this.locations];
    }

    get levels() {
        if (this.user?.level !== UserLevel.Admin) {
            return UserLevels.filter(level => level < (this.user?.level ?? 0)).map(level => ({ level, title: UserLevel[level] }));
        } else {
            return UserLevels.map(level => ({ level, title: UserLevel[level] }));
        }
    }

    @Emit("finished")
    private finished(user: IUser): IUser {
        this.addUserModel.hide();
        return user;
    }

    async addUser() {
        const toSend: CreateUserRequest = {
            locationIds: this.selectedLocationIds,
            firstName: this.addUserProps.firstName,
            lastName: this.addUserProps.lastName,
            email: this.addUserProps.email,
            level: this.addUserProps.level,
            ownerId: this.addUserProps.ownerId
        };
        const user = await apiHandler(() => Api.user.Post(toSend));
        if (user.valid) this.finished(user.user);
        else alert(user.error);
    }

    public show() {
        this.addUserProps = { locationIds: [], firstName: "", lastName: "", email: "", level: UserLevel.Employee };
        this.selectedLocationIds = [];
        this.addUserModel.show();
    }
}
